import React from 'react';
import { 
  Instagram, Facebook, Linkedin, 
  MapPin, Phone, Mail, ArrowRight, Droplets
} from 'lucide-react';
import { useNavigate , Link } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  // Navigate directly to page (top load, no scroll animation)
  const goToPage = (path: string) => {
    navigate(path);
    // No window.scrollTo, so it starts from top automatically
  };

  return (
    <footer className="bg-neutral-950 text-gray-300 pt-20 pb-10 border-t border-amber-900/30 font-sans relative overflow-hidden">
      
      {/* WAVE FOOTER */}
      <div className="absolute bottom-0 left-0 w-full h-80 z-0 pointer-events-none">
        <svg className="absolute bottom-0 w-full h-full" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="#F59E0B" 
            fillOpacity="0.25" 
            d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,149.3C672,149,768,203,864,213.3C960,224,1056,192,1152,165.3C1248,139,1344,117,1392,106.7L1440,96L1440,320L0,320Z"
          />
        </svg>
        <div className="absolute bottom-0 w-full h-32 bg-gradient-to-t from-[#F59E0B] to-transparent flex items-end justify-center pb-10"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {/* Column 1: Brand Info */}
          <div className="space-y-6">
            <div className="flex items-center gap-3 cursor-pointer">
              <div className="relative flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-blue-900 to-blue-600 shadow-lg ring-2 ring-amber-500/70">
                <Droplets size={22} className="text-white" />
              </div>
              <div className="leading-tight">
                <h2 className="text-xl font-extrabold tracking-wide bg-gradient-to-r from-amber-500 via-amber-600 to-amber-700 bg-clip-text text-transparent">
                  Luxuriya
                </h2>
                <p className="text-xs uppercase tracking-[0.3em] text-amber-600 font-semibold">
                  Waterproofing
                </p>
              </div>
            </div>

            <p className="text-sm text-gray-500 leading-relaxed pr-4">
              Protecting your home from leaks, dampness, and structural damage with expert waterproofing services you can trust.
            </p>

           <div className="flex space-x-4">
  {[
    { Icon: Instagram, link: "https://www.instagram.com/luxuriyahomes/" },
    { Icon: Facebook, link: "https://www.facebook.com/profile.php?id=61586164242497" },
    { Icon: Linkedin, link: "#" } // Linkedin ka link abhi nahi diya hai, isliye # rakha hai
  ].map(({ Icon, link }, idx) => (
    <a 
      key={idx} 
      href={link} 
      target="_blank" 
      rel="noopener noreferrer"
      className="w-10 h-10 rounded-full border border-gray-800 flex items-center justify-center hover:bg-amber-600 hover:border-amber-600 hover:text-white transition-all duration-300"
    >
      <Icon size={16} />
    </a>
  ))}
</div>
          </div>

         <ul className="space-y-4 text-sm">
  <li>
    <a 
      href="https://luxuriyahomes.com/about" 
      target="_blank"
      className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group"
    >
      <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
      About Us
    </a>
  </li>

  {/*<li>
    <a 
      href="https://luxuriyahomes.com/projects" 
      target="_blank"
      className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group"
    >
      <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
      Our Projects
    </a>
  </li>*/}

  <li>
    <a 
      href="https://luxuriyahomes.com/contact" 
      target="_blank"
      className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group"
    >
      <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
      Contact Us
    </a>
  </li>
</ul>


          {/* Column 3: Our Services */}
          <div>
            <h3 className="text-white font-serif text-lg mb-6 tracking-wide">Our Services</h3>
            <ul className="space-y-4 text-sm">
              <li>
                <button onClick={() => goToPage('/terrace-waterproofing')} className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
                  Terrace Waterproofing
                </button>
              </li>
              <li>
                <button onClick={() => goToPage('/bathroom-waterproofing')} className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
                  Bathroom Leakage
                </button>
              </li>
              <li>
                <button onClick={() => goToPage('/basement-waterproofing')} className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
                  Basement Protection
                </button>
              </li>
              <li>
                <button onClick={() => goToPage('/crack-repair')} className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
                  Crack Repair
                </button>
              </li>
              <li>
                <button onClick={() => goToPage('/roof-coating')} className="hover:text-amber-500 transition-colors duration-300 flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-[1px] bg-amber-500 transition-all duration-300"></span>
                  Roof Coating
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="text-white font-serif text-lg mb-6 tracking-wide">Get in Touch</h3>
            <div className="space-y-4 text-sm mb-8">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-amber-600 mt-1 shrink-0" />
                <p>Ithum Tower, Sector 62
<br />Noida, Uttar Pradesh, India</p>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-amber-600 shrink-0" />
                <p>+91 7291832000</p>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-amber-600 shrink-0" />
                <p>hello@luxuriyahomes.com</p>
              </div>
            </div>

            {/* Newsletter Input */}
            <div className="relative">
              <input 
                type="email" 
                placeholder="Your Email Address" 
                className="w-full bg-neutral-900 border-b border-gray-700 py-3 pl-2 pr-10 text-sm focus:outline-none focus:border-amber-600 transition-colors"
              />
              <button className="absolute right-0 top-1/2 -translate-y-1/2 text-amber-600 hover:text-white transition-colors">
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs tracking-wider text-black-700">
          <p>© 2025 Luxuriya Waterproofing. All Rights Reserved by Nadezhda Venture.</p>
          <div className="flex space-x-8">
           

<Link to="/privacy-policy" className="hover:text-white">
  Privacy Policy
</Link>

           <Link to="/terms-and-conditions" className="mx-4 hover:text-amber-500">
        Terms & Conditions
      </Link>
          </div>
        </div>
      <div className="flex space-x-8">
  
</div>
      </div>
    </footer>
  );
};

export default Footer;
